// 작업 표시줄/런처 아이콘 배지 카운트 — 데스크톱(Windows overlay icon) + Android 앱(런처 배지).
// 일반 브라우저 환경에서는 no-op.

import { isTauri } from './env';

let lastCount = -1;

// 📱 앱 복귀 시 재전송 (2026-08-29 사용자 "안드로이드 바탕화면 개수와 실제 개수가 다르다") — 백그라운드에서는 NotifyService(폴링/FCM)가
//   런처 배지를 자기 계산값으로 바꾸는데, 전면 복귀 후 웹 unreadTotal 이 lastCount 와 같으면 위 dedupe 가 재전송을 막아 네이티브 값이 남았다.
//   전면 전환 순간 dedupe 를 풀고 마지막 요청값을 한 번 더 보낸다(웹 = 정본).
if (typeof window !== 'undefined') {
	const resend = () => {
		if (document.visibilityState !== 'visible' || lastCount < 0) return;
		try { window.TPTAndroid?.setBadge?.(lastCount); } catch { /* 브릿지 없음 */ }
	};
	document.addEventListener('visibilitychange', resend);
	window.addEventListener('focus', resend);
}

export async function setBadgeCount(count: number): Promise<void> {
	const safe = Math.max(0, Math.floor(count));
	if (safe === lastCount) return; // 동일 카운트 중복 호출 차단
	lastCount = safe;
	// 📱 Android 앱 (APK code 70+) — 런처 아이콘 배지를 '안읽은 대화 배지'와 같은 수로
	//   (2026-08-22 사용자 — 폰 알림 개수 대신). 브릿지/구버전 APK 는 조용히 no-op.
	try { window.TPTAndroid?.setBadge?.(safe); } catch { /* 브릿지 없음 */ }
	if (!isTauri()) return;
	try {
		const { invoke } = await import('@tauri-apps/api/core');
		await invoke('set_badge_count', { count: safe });
	} catch (e) {
		console.warn('[desktop] setBadgeCount failed:', e);
	}
}
